import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { Strategy } from '../../../core/model/central/strategy.model';
import { strategyEntityMetadata } from './strategy.entity';

@Injectable()
export class StrategyService extends EntityCollectionServiceBase<Strategy> {
    constructor(private serviceElementsFactory: EntityCollectionServiceElementsFactory,
                private http: HttpClient) {
        super(strategyEntityMetadata.entityName, serviceElementsFactory);
    }

    getEstimatedAppointmentsAffected(strategy): Observable<number> {
        return this.http.post<any>(`servlets/strategies/${strategy.strategyId}/estimated/`,
            {
                body: strategy,
                headers: {'Content-Type': 'application/json'}
            })
        .pipe(
            map(response => response.estimatedAffected)
        );
    }

    moveNoReminderFirst(strategies: Array<Strategy>): Array<Strategy> {
        const noReminder = strategies.find(strategy => strategy.strategyName === 'No Reminder');
        if (noReminder) {
            // Return a new array to not mutate state
            return [noReminder, ...strategies.filter(strategy => strategy.strategyName !== 'No Reminder')];
        }

        return strategies;
    }
}
